import { Routes } from '@angular/router';
import { providePathwayStore } from '@app/store/pathway';
import { ModalComponent } from '@shared/components';
import { ViewComponent } from './view/view.component';

export const pathwaysModalRoutes: Routes = [
    {
        path: 'pathways/view/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...providePathwayStore()],
        children: [{ path: '', component: ViewComponent }],
    },
];
